import VModel from '@/app-core/mixins/vModel'
import {formatUnitQuantity} from '@/app-core/lib/utils/currency/currency'

export default {
  name      : 'ProductCartQuantitySelector',
  components: {},
  directives: {},
  mixins    : [VModel],
  props     : {
    product: {
      type   : Object,
      default: undefined
    },

    min: {
      type   : [Number, String],
      default: 1
    },

    max: {
      type   : [Number, String],
      default: undefined
    },

    step: {
      type   : [Number, String],
      default: 1
    },

    unitId: {
      type   : Number,
      default: 1
    },

    quantityAnimation: {
      type   : Boolean,
      default: false
    }
  },
  dataStore: {},
  data() {
    return {
      menu           : null,
      debounceTimeout: null
    }
  },
  computed: {
    quantity() {
      return this.unitId > 1 ? formatUnitQuantity(this.$i18n.locale, this.vModel, this.getMeasurementUnitById(this.unitId)) : this.vModel
    }
  },
  watch: {
    'product.LoadingUpdate': function (newVal, oldVal) {
      if (oldVal && !newVal) this.menu = false
    },

    'min': {
      immediate: true,
      handler(newVal) {
        if (newVal > this.vModel) this.vModel = newVal
      }
    }
  },
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    formatUnitQuantity,

    onRemoveClick() {
      if (!this.product) return

      this.$bus.$emit('cart:remove-product', this.product)
      this.menu = false
    },

    onDecrementClick() {
      if (!this.product) return
      if (this.vModel <= parseInt(this.min)) return

      if (this.vModel > parseInt(this.min)) this.vModel -= parseInt(this.step || 1)
      this.triggerQuantityAnimation()
      this.handleUpdateQuantity()
    },

    onIncrementClick() {
      if (!this.product) return

      if (!this.max || this.vModel < parseInt(this.max)) this.vModel += parseInt(this.step || 1)
      this.triggerQuantityAnimation()
      this.handleUpdateQuantity()
    },

    updateQuantity() {
      if (!this.product) return

      this.$bus.$emit('cart:update-product', this.product)
    },

    handleUpdateQuantity() {
      clearTimeout(this.debounceTimeout)
      this.debounceTimeout = setTimeout(() => {
        this.updateQuantity()
      }, 500)
    },

    getMeasurementUnitById(id) {
      if (!id) return null

      return this.$t('Common.Units')?.find(item => item.Id === id) || null
    },

    triggerQuantityAnimation() {
      if (!this.quantityAnimation) return

      const el = this.$refs.quantity
      if (!el) return

      el.style.animation = 'none'

      el.offsetHeight /* trigger reflow */
      el.style.animation = null
      el.classList.add('quantityTextAnimation')
    }
  }
}
